import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import General from "../components/general/General";
import { makeStyles } from '@material-ui/core/styles';
import { myparticipate } from "../functions/user"

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',
        marginBottom: '20px',
    },
}));
const MyGeneral = () => {

    const styles = useStyles();
    const [list, setList] = useState([]);
    const { user: { userID }, mypage: { type } } = useSelector(state => ({ ...state }));
    useEffect(() => {
        myparticipate(userID, type).then(res => {
            setList([...res]);
        }).catch(err => {
            console.log(err);
        });
    }, []);


    return (
        <div className={styles.container}>
            {
                list.map((item, index) => {
                    return <General
                        key={index}
                        _id={item._id}
                        title={item.title}
                        content={item.content}
                        date={item.date}
                        author={item.author}
                        image_urls={item.image_urls}
                        polls={item.polls}
                        comments={item.comments}
                        likes={item.likes}
                        participants_userids={item.participants_userids}
                        done={item.done}
                    />

                })
            }

        </div>
    );
};

export default MyGeneral;